import { Box, Chip, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import AnimatedTable, { ColumnDef } from "../AnimatedTable";
import { useState } from "react";

const mockRentals = [
  {
    id: 1,
    client: "EventHouse Media",
    rental: "01/04/2026 - 03/04/2026",
    status: "2026-05-15",
    price: "$100",
    condition: "Active",
  },
  {
    id: 2,
    client: "Tech Innovators Conference",
    rental: "15/05/2026 - 17/05/2026",
    status: "2026-06-01",
    price: "$50",
    condition: "Complete",
  },
  {
    id: 3,
    client: "Global Sustainability Summit",
    rental: "22/06/2026 - 24/06/2026",
    status: "2026-07-10",
    price: "$150",
    condition: "Complete",
  },
];

export default function RentalsTab() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [rentalPage, setRentalPage] = useState(0);

  const chipSx = {
    bgcolor: colors.neutral[700],
    color: theme.palette.text.primary,
    fontWeight: 600,
    borderRadius: "16px",
  };

  const rentalColumns: ColumnDef<(typeof mockRentals)[0]>[] = [
    {
      key: "client",
      label: "Client",
      cellSx: { fontWeight: 500, color: theme.palette.text.primary },
      render: (row) => row.client,
    },
    { key: "rental", label: "Rental", render: (row) => row.rental },
    { key: "status", label: "Status", render: (row) => row.status },
    { key: "price", label: "Price", render: (row) => row.price },
    {
      key: "condition",
      label: "Condition",
      render: (row) => (
        <Chip
          label={row.condition}
          size="small"
          sx={{
            ...chipSx,
            backgroundColor:
              row.condition === "Active"
                ? colors.primary[900]
                : colors.neutral[700],
            border:
              row.condition === "Active"
                ? `1px solid ${colors.primary[300]}`
                : "none",
          }}
        />
      ),
    },
  ];

  return (
    <Box>
      {/* <Box
        sx={{
          backgroundColor: colors.primary[600], borderRadius: "12px", p: 2, mb: 3,
          display: "flex", justifyContent: "space-between", alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="caption" color={theme.palette.text.secondary} sx={{ mb: 0.5, display: "block" }}>Active Rental</Typography>
          <Typography variant="subtitle1" color={theme.palette.text.primary} fontWeight="bold">EventHouse Media</Typography>
          <Typography variant="caption" color={theme.palette.text.primary}>01 April 2026 → 03 April 2026</Typography>
        </Box>
        <Button
          variant="contained" startIcon={<CheckCircleOutline />}
          sx={{ backgroundColor: colors.primary[400], color: theme.palette.text.primary, textTransform: "none", borderRadius: "8px", px: 3 }}
        >
          Mark as returned
        </Button>
      </Box> */}

      <AnimatedTable
        columns={rentalColumns}
        rows={mockRentals}
        getRowId={(row) => row.id}
        page={rentalPage}
        totalPages={1}
        onPageChange={setRentalPage}
        emptyMessage="No rentals found."
      />
    </Box>
  );
}
